export default __webpack_public_path__ + "static/media/238.640c7ab2.gif";